import React from 'react';

const DeltaArrowIcon = ({
	direction,
	color = 'currentColor',
	className = '',
}: {
	direction: 'up' | 'down';
	color?: string;
	className?: string;
}) => {
	const rotation = direction === 'up' ? 'rotate(180deg)' : undefined;

	return (
		<svg
			width="8"
			height="10"
			viewBox="0 0 8 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			style={{ transform: rotation, display: 'inline-block', verticalAlign: 'middle' }}
		>
			<path
				d="M7.01516 6.73127C7.05355 6.69962 7.08485 6.66041 7.10706 6.61614C7.12927 6.57187 7.14191 6.52352 7.14416 6.47415C7.14642 6.42479 7.13825 6.3755 7.12017 6.32943C7.10208 6.28336 7.07449 6.24152 7.03915 6.20658C7.0038 6.17164 6.96148 6.14436 6.91488 6.12649C6.86828 6.10861 6.81842 6.10053 6.76848 6.10277C6.71855 6.105 6.66963 6.11749 6.62485 6.13944C6.58007 6.1614 6.54041 6.19234 6.50839 6.23029L3.91981 8.78628L3.91981 0.337797C3.91491 0.246596 3.87482 0.160724 3.80778 0.0978783C3.74075 0.0350323 3.65188 -1.52669e-07 3.55949 -1.56707e-07C3.46711 -1.60745e-07 3.37824 0.0350323 3.31121 0.0978783C3.24417 0.160724 3.20407 0.246596 3.19918 0.337797L3.19918 8.78628L0.613635 6.22628C0.545377 6.16185 0.454628 6.1259 0.360249 6.1259C0.26587 6.1259 0.175121 6.16185 0.106863 6.22628C0.0735216 6.25914 0.0470672 6.29818 0.029017 6.34116C0.0109663 6.38415 0.00167465 6.43023 0.00167465 6.47677C0.00167465 6.52331 0.0109663 6.56939 0.029017 6.61238C0.0470672 6.65536 0.0735216 6.6944 0.106863 6.72726L3.30966 9.89344C3.34247 9.92713 3.38182 9.95394 3.42536 9.97225C3.4689 9.99056 3.51573 10 3.56304 10C3.61036 10 3.65718 9.99056 3.70072 9.97225C3.74426 9.95394 3.78361 9.92713 3.81643 9.89344L7.01516 6.73127Z"
				fill={color}
			/>
		</svg>
	);
};

export default DeltaArrowIcon;
